<template>
  <div id="storecontainer">
    <div id="storelist">
      <StoreObjectContainer v-for="object in storeObjects.slice().reverse()" :key="object.id" :object="object" :isMobile="isMobile"/>
    </div>
    <div class="ml-4 draggable pp fixed top-0 mt-16 md:ml-16" id="faq" :class="{ desktop_d : !isMobile }">
      <p v-if="content.title" class="t">{{ content.title }}</p>
      <vue-markdown :source="content.FAQ"></vue-markdown>
    </div>
  </div>
</template>

<script>
import interact from "interactjs";
import StoreObjectContainer from "@/components/StoreObjectContainer.vue";

export default {
  name: "Available",
  components: {
    StoreObjectContainer
  },
  props: [
    'isMobile'
  ],
  data() {
    return {
      storeObjects: {},
      content: {},
      url: process.env.VUE_APP_VPS_URL,
    }
  },
  created() {
    let selfobject = this;
    this.$http.get(selfobject.url + '/store-objects')
      .then(function (response) {
        selfobject.storeObjects = response["data"];
      })
    this.$http.get(selfobject.url + '/store-page')
      .then(function (response) {
        selfobject.content = response["data"];
      })
  },
  mounted() {
    this.enableDragDrop();
  },
  methods: {
    enableDragDrop() {
      const htmlList = document.getElementsByClassName('draggable'); 
      for (let htmlItem of htmlList) {
      let x = 0;
      let y = 0;
        interact(htmlItem)
          .draggable({
            modifiers: [
              interact.modifiers.snap({
                targets: [interact.createSnapGrid({ x: 25, y: 25 })],
                range: Infinity,
                relativePoints: [{ x: 0, y: 0 }]
              }),
              interact.modifiers.restrict({
                restriction: document.getElementById('body'),
                elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              })
            ],
            inertia: true
          })
          .on("dragmove", function(event) {
            x += event.dx;
            y += event.dy;

            event.target.style.webkitTransform = event.target.style.transform =
              "translate(" + x + "px, " + y + "px)";
          });
      }
    }
  }

}
</script>
<style>
#storecontainer {
  width:100%;
  height:100%;
  overflow: auto;
}

#storelist {
  padding-top:80px;
  padding-bottom:80px;
}

#faq {
  background-color:rgb(238, 238, 238);
  border: 1px solid black;
  background-image: url('../assets/drag.svg');
  background-position-y: top;
  background-size: 15px;
  background-position-x: left;
  background-repeat: no-repeat;
  text-align:left;
  padding:0px 15px 0 15px;
  z-index:75;
  pointer-events:all;
  touch-action: none;
  width:80%;
  }

#faq.desktop_d {
  width:40%;
  left:38%;
  top:2%;
}

.desktop_d p, .desktop_d .t, .desktop_d a {
  font-size:18px;
}

.desktop_d {
  width: 50vw;
}


.pp * {
  text-align:left;
  font-size:16px;
  margin-block-start: 5px;
  margin-block-end: 14px;
}

p {
  margin-block-start:0px;
  margin-block-end:0px;
}

.t {
  font-family: L;
  font-size:16px;
  text-transform: uppercase;
  margin-top:14px;
  margin-bottom:0px;
  margin-block-end: 0px;
}
</style>